export const userErrorCodes = {
  MAX_AMOUNT_OF_DEVICES_REACHED: 434,
  DEVICE_ALREADY_ADDED_STATUS_CODE: 422
};
